var map = {
	"./high_btn.png": 9518,
	"./low_btn.png": 8352,
	"./m_high+_btn.png": 657,
	"./m_high_btn.png": 1958,
	"./m_low_btn.png": 2952,
	"./medium_btn.png": 3199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6683;